import moment from "moment";
import { getDayLabelNumber } from "./wordForm";

export function getMonthFormat(date) {
  return moment(date).format("MM.YYYY");
}

export function getDateFormat(date) {
  return moment(date).format("DD.MM.YYYY");
}

export function getTimeFormat(date) {
  return moment(date).format("HH:mm");
}

export function getNow() {
  return setZero(new Date());
}

export function setZero(now) {
  now.setHours(6);
  now.setMinutes(0);
  now.setSeconds(1);

  return now;
}

export function getMonthStringFromDate(date) {
  return `${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`;
}

export function getDateStringFromDate(date) {
  return `${("0" + date.getDate()).slice(-2)}.${(
    "0" +
    (date.getMonth() + 1)
  ).slice(-2)}.${date.getFullYear()}`;
}

export function getTwoDatesFromOneDate(date) {
  const tomorrow = new Date(date);
  tomorrow.setDate(date.getDate() + 1);

  const yesterday = new Date(date);
  yesterday.setDate(date.getDate());

  const yesterdayIsoDate = yesterday.toISOString();
  const tomorrowIsoDate = tomorrow.toISOString();

  return { $gte: yesterdayIsoDate, $lt: tomorrowIsoDate };
}

export function getTwoDatesFromTwoDates(from, to) {
  const yesterday = setZero(new Date(from));
  yesterday.setDate(from.getDate());

  const tomorrow = setZero(new Date(from));
  tomorrow.setDate(to.getDate() + 1);

  const yesterdayIsoDate = yesterday.toISOString();
  const tomorrowIsoDate = tomorrow.toISOString();

  return { $gte: yesterdayIsoDate, $lt: tomorrowIsoDate };
}

export function getTwoDatesFromTwoStringDates(from, to) {
  const result = {
    isCorrect: false,
    dates: null,
    message: null
  };

  const resultFrom = getDateFromDatepicker(from, true);
  if (!resultFrom.isCorrect) {
    result.message = "from = " + resultFrom.message;
    return result;
  }
  const yesterday = resultFrom.date;

  const resultTo = getDateFromDatepicker(to, true);
  if (!resultTo.isCorrect) {
    result.message = "to = " + resultTo.message;
    return result;
  }
  const tomorrow = resultTo.date;
  tomorrow.setDate(tomorrow.getDate() + 1);

  const yesterdayIsoDate = yesterday.toISOString();
  const tomorrowIsoDate = tomorrow.toISOString();

  result.isCorrect = true;
  result.dates = { $gte: yesterdayIsoDate, $lt: tomorrowIsoDate };

  return result;
}

/**
 * Проверка на натуральное число
 * @num - число
 */
export function isInteger(num) {
  return (num ^ 0) === num;
}

/**
 * Проверка на высокосный год
 * @year - год
 */
export function isHighFebruary(year) {
  return !!isInteger(year / 4);
}

/**
 * Колличество дней в месяце
 * @month - месяц
 * @year - год
 */
export function getDaysInMonth(month, year) {
  const M_31 = [1, 3, 5, 7, 8, 10, 12];
  const M_30 = [4, 6, 9, 11];
  if (month === 2) {
    if (!year) return null;
    else if (isHighFebruary(year)) return 29;
    else return 28;
  } else if (M_31.includes(month)) return 31;
  else if (M_30.includes(month)) return 30;
  else return null;
}

/**
 * Колличество дней в году
 * @year - год
 **/
export function getDaysInYear(year) {
  let sumDays = 0;
  for (let i = 1; i <= 12; i++) {
    sumDays += getDaysInMonth(i, year);
  }
  return sumDays;
}

/**
 * Оставшееся количество дней до конца месяца
 * @day - текущий день
 * @daysInMonth - всего дней в месяце
 **/
export function getDaysToEndMonth(day, daysInMonth) {
  if (daysInMonth) return daysInMonth - day;
  else return null;
}

/**
 * Оставшееся количество дней с начала или с конца года
 * @dateArray - дата в массиве [YYYY, MM, DD]
 * @isFromStart - считать сколько дней прошло с начала года
 * Где MM, 01 - январь
 **/
export function getDaysToEndAndStartYear(dateArray, isFromStart) {
  let daysAllInYear = getDaysInYear(dateArray[0]);
  let daysFromStartToToday = 0;
  for (let i = 1; i < dateArray[1]; i++) {
    daysFromStartToToday += getDaysInMonth(i, dateArray[0]);
  }
  daysFromStartToToday += dateArray[2];
  return isFromStart
    ? daysFromStartToToday
    : daysAllInYear - daysFromStartToToday;
}

/**
 * Сколько разницы в днях
 * @dayReturn - день возврата
 * @dayToday - текущий день
 * $знак - < - в прошлом | > - в следующем | = - в этом
 * return [колличество дней, $знак]
 */
export function getMinusDay(dayReturn, dayToday) {
  let dayResult = dayReturn - dayToday;
  if (dayResult === 0) return [0, "="];
  else return dayResult < 0 ? [dayResult * -1, "<"] : [dayResult, ">"];
}

/**
 * Сколько разницы в месяцах
 * @monthReturn - месяц возврата
 * @monthToday - текущий месяц
 * $знак - < - в прошлом | > - в следующем | = - в этом
 * return [колличество месяцев, $знак]
 */
export function getMinusMonth(monthReturn, monthToday) {
  let monthResult = monthReturn - monthToday;
  if (monthResult === 0) return [0, "="];
  else return monthResult < 0 ? [monthResult * -1, "<"] : [monthResult, ">"];
}

/**
 * Сколько разницы в годах
 * @yearReturn - год возврата
 * @yearToday - текущий год
 * $знак - < - в прошлом | > - в следующем | = - в этом
 * return [колличество месяцев, $знак]
 */
export function getMinusYear(yearReturn, yearToday) {
  let yearResult = yearReturn - yearToday;
  if (yearResult === 0) return [0, "="];
  else return yearResult < 0 ? [yearResult * -1, "<"] : [yearResult, ">"];
}

/**
 * Получить дату в виде массива цифр (integer)
 * @dateString - дата в формате "YYYY-MM-DD"
 * return [YYYY, MM, DD]
 */
export function getArrayFromDateString(dateString) {
  return dateString
    .substr(0, 10)
    .split("-")
    .map(item => {
      return parseInt(item, 10);
    });
}

/**
 * Колличество дней между месяцами
 * @dateFirst - начальная дата в массиве [YYYY, MM, DD]
 * @dateSecond - конечная дата в массиве [YYYY, MM, DD]
 * Где MM, 01 - январь
 **/
export function getSumDaysFromMonth(dateFirst, dateSecond) {
  let sumDays = 0;
  sumDays += getDaysToEndMonth(
    dateFirst[2],
    getDaysInMonth(dateFirst[1], dateFirst[0])
  );
  for (let i = dateFirst[1] + 1; i < dateSecond[1]; i++) {
    sumDays += getDaysInMonth(i, dateFirst[1]);
  }
  sumDays += dateSecond[2];
  return sumDays;
}

/**
 * Колличество дней между годами
 * @dateFirst - начальная дата в массиве [YYYY, MM, DD]
 * @dateSecond - конечная дата в массиве [YYYY, MM, DD]
 * Где MM, 01 - январь
 **/
export function getSumDaysFromYear(dateFirst, dateSecond) {
  let sumDays = 0;
  sumDays += getDaysToEndAndStartYear(dateFirst);
  for (let i = dateFirst[0] + 1; i < dateSecond[0]; i++) {
    sumDays += getDaysInYear(i);
  }
  sumDays += getDaysToEndAndStartYear(dateSecond, true);
  return sumDays;
}

/**
 * В каком периоде находится дата возврата
 * @minusYear - период годов
 * @minusMonth - период месяцев
 * @minusDay - период дней
 * $знак - < - в прошлом | > - в следующем | = - в этом
 * return $знак
 **/
export function getPeriodReturn(minusYear, minusMonth, minusDay) {
  if (minusYear === ">" || minusYear === "<") return minusYear;
  else if (minusYear === "=") {
    if (minusMonth === ">" || minusMonth === "<") return minusMonth;
    else if (minusMonth === "=") return minusDay;
    else return null;
  } else return null;
}

/**
 * @returnString - дата возврата в формате "YYYY-MM-DD"
 * @todayString - текущая дата в формате "YYYY-MM-DD"
 * @isConsoleLog - вывести в лог
 * Где MM, 01 - январь
 **/
export function getSumDaysFromTwoDates(
  returnString,
  todayString,
  isConsoleLog
) {
  let dateReturn = getArrayFromDateString(String(returnString));
  let dateToday = getArrayFromDateString(String(todayString));
  let minusYear = getMinusYear(dateReturn[0], dateToday[0]);
  let minusMonth = getMinusMonth(dateReturn[1], dateToday[1]);
  let minusDay = getMinusDay(dateReturn[2], dateToday[2]);
  let periodMinus = getPeriodReturn(minusYear[1], minusMonth[1], minusDay[1]);
  let sumDaysOfAllMonth = 0;
  if (minusYear[1] === ">")
    sumDaysOfAllMonth = getSumDaysFromYear(dateToday, dateReturn);
  else if (minusYear[1] === "=") {
    if (minusMonth[1] === "=") sumDaysOfAllMonth = minusDay[0];
    else if (minusMonth[1] === "<")
      sumDaysOfAllMonth = getSumDaysFromMonth(dateReturn, dateToday);
    else if (minusMonth[1] === ">")
      sumDaysOfAllMonth = getSumDaysFromMonth(dateToday, dateReturn);
  } else if (minusYear[1] === "<")
    sumDaysOfAllMonth = getSumDaysFromYear(dateReturn, dateToday);
  else return null;

  if (isConsoleLog) {
    console.log("Года:", minusYear, "Месяцы:", minusMonth, "Дни:", minusDay);
    console.log("-------------------------------------------");
    console.log("Возврат:", dateReturn, "Текущая:", dateToday);
    console.log("-------------------------------------------");
  }

  // noinspection JSValidateTypes
  return [sumDaysOfAllMonth, periodMinus];
}

/**
 * Получить дату из строки формата DD.MM.YYYY или MM.YYYY
 * @param {*} date - Дата в строке
 * @param {*} setNowZero - Установить начальные часы
 * @param {*} isReturnIso - Вернуть в Iso
 * @returns {Object} {isCorrect: false, date: null, message: null}
 */
export function getDateFromDatepicker(date, setNowZero, isReturnIso) {
  const result = {
    isCorrect: false,
    date: null,
    message: null
  };

  function checkInvalidDate(newDateResult) {
    if (newDateResult !== "Invalid Date") {
      result.date = newDateResult;
      result.isCorrect = true;
    } else {
      result.message = "Invalid Date";
    }
  }

  if (typeof date === "string") {
    // 29.08.2018
    if (String(date).length === 10) {
      // Ищем вот такие даты: 12.12.2018 || 12,12,2018
      const resultRegExp = date.match(/(\d{2})[.,](\d{2})[.,](\d{4})/y);

      if (resultRegExp && resultRegExp.length === 4) {
        const day = parseInt(resultRegExp[1], 10);
        const month = parseInt(resultRegExp[2], 10);
        const year = parseInt(resultRegExp[3], 10);

        if (
          day > 0 &&
          day <= 31 &&
          month > 0 &&
          month <= 12 &&
          year > 1900 &&
          year <= 2999 &&
          (((month === 1 ||
            month === 3 ||
            month === 5 ||
            month === 7 ||
            month === 8 ||
            month === 10 ||
            month === 12) &&
            day <= 31) ||
            (month === 2 &&
              ((year % 4 === 0 && day <= 29) ||
                (year % 4 !== 0 && day <= 28))) ||
            ((month === 4 || month === 6 || month === 9 || month === 11) &&
              day <= 30))
        ) {
          const newDateResult = new Date(year, month - 1, day, 6, 1, 0);

          checkInvalidDate(newDateResult);
        } else {
          result.message = "Неправильная дата, check";
        }
      } else {
        result.message = "Неправильная дата, regexp";
      }
    } else if (String(date).length === 7) {
      // 08.2018
      const resultRegExp = date.match(/(\d{2})\.(\d{4})/y);

      if (resultRegExp && resultRegExp.length === 3) {
        const month = parseInt(resultRegExp[1], 10);
        const year = parseInt(resultRegExp[2], 10);

        if (month > 0 && month <= 12 && year > 1900 && year <= 2999) {
          const newDateResult = new Date(year, month - 1, 1, 6, 1, 0);

          checkInvalidDate(newDateResult);
        } else {
          result.message = "Неправильная дата, check";
        }
      } else {
        result.message = "Неправильная дата, regexp";
      }
    } else {
      result.message = "Неправильная дата, length";
    }
  } else if (typeof date === "object") {
    const newDateResult = new Date(date);

    checkInvalidDate(newDateResult);
  } else {
    result.message = "Неправильная дата, not string or date";
  }

  if (result.isCorrect && setNowZero) {
    result.date = setZero(result.date);
  }

  if (result.isCorrect && isReturnIso) {
    result.date = result.date.toISOString();
  }

  return result;
}

export function setDateFromDatepickerInObject(payload, arrayFields) {
  arrayFields.forEach(nameField => {
    if (payload[nameField] && payload[nameField].length) {
      const resultDate = getDateFromDatepicker(payload[nameField], true, true);

      if (resultDate.isCorrect) {
        payload[nameField] = resultDate.date;
      } else {
        delete payload[nameField];
      }
    }
  });
}

export function getDateReturnDaysString(dateReturn, isReturnStringOnly) {
  const returnResult = {
    string: "",
    style: ""
  };

  let datePrepared = null;
  if (dateReturn.length === 10) {
    const resultPrepared = getDateFromDatepicker(dateReturn, true, false);
    if (resultPrepared.isCorrect) {
      datePrepared = resultPrepared.date;
    }
  } else {
    datePrepared = new Date(dateReturn);
  }

  // eslint-disable-next-line eqeqeq
  if (moment.isDate(datePrepared) && datePrepared != "Invalid Date") {
    const daysFinish = getSumDaysFromTwoDates(
      datePrepared.toISOString(),
      new Date().toISOString()
    );

    if (daysFinish[1] === "<" && daysFinish[0] > 10) {
      returnResult.style = "error";
      returnResult.string = getDayLabelNumber(daysFinish[0]) + " назад";
    } else if (daysFinish[1] === "<" && daysFinish[0] <= 10) {
      returnResult.style = "warning-active";
      returnResult.string = getDayLabelNumber(daysFinish[0]) + " назад";
    } else if (daysFinish[1] === "=" && daysFinish[0] === 0) {
      returnResult.style = "dark";
      returnResult.string = "Сегодня";
    } else if (daysFinish[1] === ">" && daysFinish[0] === 1) {
      returnResult.style = "grey";
      returnResult.string = "Завтра";
    } else {
      returnResult.style = "default";
      returnResult.string = "Через " + getDayLabelNumber(daysFinish[0]);
    }
  }

  if (isReturnStringOnly) {
    return returnResult.string;
  } else {
    return returnResult;
  }
}

export function isSameDateOnDay(date1, date2) {
  return moment(date1).isSame(date2, "day");
}
